import type { AssetClassRollup, Currency } from '../../shared/types';
import { Donut, type DonutSlice } from './Donut';

const CLASS_COLORS: Record<string, string> = {
  equity: 'var(--class-equity)',
  crypto_volatile: 'var(--class-crypto)',
  bond: 'var(--class-bond)',
  cash_eq: 'var(--class-cash)',
  gold: 'var(--class-gold)',
  real_estate: 'var(--class-real-estate)',
  alternatives: 'var(--class-alternatives)',
  private_equity: 'var(--class-pe)',
};

const CLASS_LABEL: Record<string, string> = {
  equity: 'Equities',
  crypto_volatile: 'Crypto',
  bond: 'Bonds',
  cash_eq: 'Cash Eq.',
  gold: 'Gold',
  real_estate: 'Real Estate',
  alternatives: 'Alternatives',
  private_equity: 'Private Equity',
};

export function AssetClassDonut({
  rollup,
  ccy,
}: {
  rollup: AssetClassRollup[];
  ccy: Currency;
}) {
  const slices: DonutSlice[] = rollup.map((r) => ({
    id: r.class,
    label: CLASS_LABEL[r.class] ?? r.class,
    value: ccy === 'USD' ? r.value_usd : r.value_eur,
    color: CLASS_COLORS[r.class] ?? 'var(--class-equity)',
  }));
  return <Donut data={slices} ccy={ccy} ariaLabel="Asset class allocation" />;
}
